import React, { FC } from 'react';

const CategoriesNavIcon: FC<{ color?: string }> = ({ color = '#111827' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ color }}>
      <path
        d="M10.5 8.57422V9.42383H1.5V8.57422H10.5ZM10.5 5.57422V6.42383H1.5V5.57422H10.5ZM10.5 2.57422V3.42383H1.5V2.57422H10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CategoriesNavIcon;
